module.exports = "/shifts/components/shiftBoxIconComponent-f65f79.html";